import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    public oidcSecurityService: OidcSecurityService
  ) {}

  ngOnInit(): void {
    let hint = 'optum-id'; //kc_idp_hint - One Healthcare ID (OHID)	optum-id
    let userType = this.route.snapshot.params['usertype'];
    if (userType != undefined && userType == "pdi" ) {
      hint = 'uhg-ms-id'; //kc_idp_hint - MSID	uhg-ms-id
    }

    // Read OPRO parameters from URL query string
    const queryParams = this.route.snapshot.queryParams;
    const source = queryParams['source'];
    const tin = queryParams['tin'];
    const role = queryParams['role'];
    const additionalTins = queryParams['additionalTins'];
    const npi = queryParams['npi'];

    // Build custom params object
    const customParams: any = { kc_idp_hint: hint };
    
    // Store OPRO parameters in sessionStorage for callback retrieval
    const oProParams = {
      source: source || '',
      tin: tin || '',
      role: role || '',
      additionalTins: additionalTins || '',
      npi: npi || '',
      user_type: userType || ''
    };
    
    // Store in sessionStorage if OPRO source parameter exists, otherwise clear it
    if (source === 'opro') {
      sessionStorage.setItem('oProParams', JSON.stringify(oProParams));
      console.log('OPRO Parameters stored in sessionStorage:', oProParams);
    } else {
      // Clear sessionStorage if source is not 'opro' or not present
      sessionStorage.removeItem('oProParams');
      console.log('OPRO sessionStorage cleared - source parameter not detected or not "opro"');
    }
    
    // Add OPRO parameters if they exist
   
    
    this.oidcSecurityService.setState(userType).subscribe((result) => {
      this.oidcSecurityService.authorize(undefined, { customParams: { kc_idp_hint: hint }});
    });
  }

  
}
